import TextXS from './TextXS';

export default TextXS;
